import { Box, BoxProps } from "@mui/material";
import { Link as RouterLink } from "@tanstack/react-router";
import { PATH_DASHBOARD } from "src/utils/paths";

// ----------------------------------------------------------------------

interface Props extends BoxProps {
	disabledLink?: boolean;
	width?: number;
	height?: number;
	onClick?: () => void;
}

export default function LogoIso({
	disabledLink = false,
	sx,
	width = 150,
	height = 50,
	onClick
}: Props) {
	const logo = (
		<Box sx={{ ...sx }} onClick={onClick}>
			<svg
				fill='none'
				height={height}
				viewBox='0 0 2059 527'
				width={width}
				xmlns='http://www.w3.org/2000/svg'
			>
				<g filter='url(#filter0_d_5667_24210)'>
					<path
						d='M882.7 434.7C872.9 434.7 864 433.4 855.9 430.8C847.8 428.2 840.6 424.3 834.3 419C828 413.8 822.4 407.2 817.6 399.4C812.8 391.5 808.8 382.4 805.6 371.9L761.8 229.3L718 86.6001H756H794L833.3 218.6L872.6 350.6C873.3 352.3 874 353.8 874.7 355C875.4 356.2 876.2 357.3 876.9 358.2C877.7 359 878.6 359.7 879.6 360.1C880.6 360.5 881.9 360.7 883.2 360.7C884.6 360.7 885.8 360.5 886.8 360.1C887.8 359.7 888.8 359 889.5 358.2C890.3 357.4 891 356.3 891.6 355C892.2 353.7 892.8 352.3 893.3 350.6L932.3 218.6L971.3 86.6001H1009.3H1047.3L1003.5 229.2L959.7 371.8C956.5 382.3 952.5 391.4 947.8 399.3C943.1 407.2 937.6 413.7 931.3 418.9C925 424.1 917.9 428.1 909.8 430.7C901.7 433.4 892.7 434.7 882.7 434.7Z'
						fill='#FF9634'
					/>
					<path
						d='M1239.4 433.1C1213.9 433.1 1191.8 429.6 1173 422.7C1154.2 415.8 1138.9 405.4 1126.9 391.5C1114.9 377.7 1105.9 361.1 1099.9 341.8C1093.9 322.5 1090.9 300.6 1090.9 275.9V181.1V86.6001H1127.9H1164.9V180.6V274.6C1164.9 289.5 1166.4 302.4 1169.5 313.5C1172.6 324.6 1177.2 333.7 1183.4 341C1189.6 348.3 1197.3 353.7 1206.6 357.3C1215.9 360.9 1226.8 362.7 1239.3 362.7C1251.8 362.7 1262.7 360.9 1272 357.3C1281.3 353.7 1289.1 348.2 1295.2 341C1301.4 333.7 1306 324.6 1309.1 313.5C1312.2 302.4 1313.7 289.5 1313.7 274.6V180.6V86.6001H1350.7H1387.7V181.4V276.2C1387.7 300.9 1384.7 322.8 1378.6 342.1C1372.6 361.4 1363.5 377.9 1351.4 391.8C1339.3 405.7 1323.9 416 1305.2 423C1286.8 429.7 1264.8 433.1 1239.4 433.1Z'
						fill='#FF9634'
					/>
					<path
						d='M1522.7 427.6H1485.2H1447.7L1470.8 280.9L1493.9 134.2C1495.4 125.3 1498 117.4 1501.7 110.6C1505.4 103.8 1510.1 98.1999 1516 93.5999C1521.8 88.9999 1528.3 85.5999 1535.6 83.2999C1542.8 80.9999 1550.7 79.8999 1559.4 79.8999C1567 79.8999 1574.2 80.7999 1580.9 82.5999C1587.6 84.3999 1594 87.0999 1599.9 90.7999C1605.8 94.3999 1610.7 99.1999 1614.7 105.1C1618.7 111 1621.7 118 1623.7 126.1L1652.3 232.5L1680.9 338.9C1680.9 339.4 1680.9 339.8 1681 340C1681.1 340.3 1681.2 340.4 1681.4 340.4C1681.6 340.4 1681.7 340.4 1681.8 340.3C1681.9 340.3 1682 340.2 1682.1 340.1C1682.2 340 1682.2 339.9 1682.3 339.7C1682.4 339.5 1682.4 339.2 1682.4 338.9L1710.5 233.3L1738.6 127.7C1740.8 119.4 1744 112.3 1748.1 106.2C1752.2 100.2 1757.3 95.1999 1763.4 91.3999C1769.5 87.5999 1775.9 84.6999 1782.8 82.7999C1789.6 80.8999 1796.9 79.9999 1804.5 79.9999C1812.9 79.9999 1820.7 81.1999 1827.8 83.4999C1834.9 85.8999 1841.3 89.3999 1847.1 94.0999C1852.8 98.7999 1857.4 104.7 1860.9 111.6C1864.4 118.5 1866.7 126.5 1867.9 135.7L1888.9 281.6L1909.9 427.5H1872.4H1834.9L1818.4 293.7L1801.9 159.9C1801.9 159.1 1801.9 158.4 1801.8 157.8C1801.7 157.2 1801.6 156.8 1801.4 156.6C1801.2 156.3 1801 156.2 1800.6 156C1800.3 155.9 1799.8 155.8 1799.3 155.8C1799 155.8 1798.6 155.9 1798.3 156C1798 156.1 1797.7 156.3 1797.5 156.6C1797.2 156.9 1797 157.2 1796.8 157.6C1796.6 158 1796.4 158.4 1796.2 158.9L1764.5 271.9L1732.8 384.9C1730.9 391.3 1728.4 396.9 1725.1 401.8C1721.8 406.7 1717.9 410.6 1713.3 413.8C1708.6 417 1703.6 419.4 1698.3 421C1693 422.6 1687.2 423.4 1681.1 423.4C1675.4 423.4 1669.8 422.6 1664.5 421.1C1659.2 419.6 1654.1 417.3 1649.2 414.3C1644.3 411.3 1640.2 407.4 1637 402.8C1633.8 398.2 1631.4 392.7 1629.9 386.5L1598.2 272.7L1566.5 158.9C1566.5 158.2 1566.4 157.7 1566.3 157.3C1566.2 156.9 1566 156.6 1565.7 156.4C1565.4 156.2 1565.2 156.1 1564.9 156C1564.6 155.9 1564.3 155.9 1564 155.9C1563.5 155.9 1563.1 156 1562.7 156.1C1562.3 156.2 1562 156.4 1561.7 156.7C1561.4 157 1561.3 157.3 1561.1 157.8C1561 158.3 1560.9 158.8 1560.9 159.5L1541.6 293.5L1522.7 427.6Z'
						fill='#FF9634'
					/>
					<path
						d='M2010.1 139.3C2006 139.3 2002.1 138.8 1998.4 137.8C1994.6 136.8 1991 135.4 1987.6 133.4C1984.1 131.5 1981.1 129.1 1978.4 126.4C1975.7 123.7 1973.4 120.6 1971.4 117.1C1969.5 113.6 1968 110 1967 106.3C1966 102.6 1965.5 98.6 1965.5 94.6C1965.5 90.5 1966 86.7 1967 82.9C1968 79.1 1969.4 75.6 1971.4 72.3C1973.3 68.9 1975.7 65.9 1978.4 63.2C1981.1 60.5 1984.2 58.1 1987.6 56.1C1991.1 54.1 1994.7 52.6 1998.4 51.5C2002.2 50.5 2006.1 50 2010.1 50C2014.2 50 2018 50.5 2021.8 51.5C2025.5 52.5 2029.1 54 2032.4 56.1C2035.8 58.1 2038.8 60.5 2041.5 63.2C2044.2 65.9 2046.5 68.9 2048.4 72.3C2050.3 75.7 2051.8 79.2 2052.8 82.9C2053.8 86.6 2054.3 90.5 2054.3 94.6C2054.3 98.7 2053.8 102.6 2052.8 106.3C2051.8 110.1 2050.4 113.7 2048.4 117.1C2046.5 120.6 2044.2 123.6 2041.5 126.4C2038.8 129.1 2035.8 131.4 2032.4 133.4C2029 135.3 2025.5 136.8 2021.8 137.8C2018.1 138.8 2014.2 139.3 2010.1 139.3ZM1974.1 176.8H2010.1H2046.1V302.2V427.6H2010.1H1974.1V302.2V176.8Z'
						fill='#FF9634'
					/>
					<path
						d='M137.924 119.375C157.224 100.075 188.524 100.075 207.824 119.375C227.124 138.675 227.124 169.975 207.824 189.275C188.524 208.575 157.224 208.575 137.924 189.275C118.624 169.975 118.624 138.675 137.924 119.375Z'
						fill='#FF9634'
					/>
					<path
						d='M242.924 14.475C262.224 -4.825 293.524 -4.825 312.824 14.475L417.724 119.375C437.024 138.675 437.024 169.975 417.724 189.275L312.824 294.275C293.524 313.575 262.224 313.575 242.924 294.275C223.624 274.975 223.624 243.675 242.924 224.375L277.924 189.375C297.224 170.075 297.224 138.775 277.924 119.475L242.924 84.475C223.624 65.075 223.624 33.775 242.924 14.475Z'
						fill='#FF9634'
					/>
					<path
						d='M452.725 224.275L312.825 364.175C293.525 383.475 262.225 383.475 242.925 364.175L103.025 224.275C83.725 204.975 52.425 204.975 33.125 224.275L8.125 249.275C2.625 254.775 2.625 263.675 8.125 269.175L242.925 504.075C262.225 523.375 293.525 523.375 312.825 504.075L547.625 269.275C553.125 263.775 553.125 254.875 547.625 249.375L522.625 224.375C503.325 204.975 472.025 204.975 452.725 224.275Z'
						fill='#FF9634'
					/>
				</g>
				<defs>
					<filter
						colorInterpolationFilters='sRGB'
						filterUnits='userSpaceOnUse'
						height='526.55'
						id='filter0_d_5667_24210'
						width='2058.3'
						x='0'
						y='0'
					>
						<feFlood floodOpacity='0' result='BackgroundImageFix' />
						<feColorMatrix
							in='SourceAlpha'
							result='hardAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite in2='hardAlpha' operator='out' />
						<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
						<feBlend
							in2='BackgroundImageFix'
							mode='normal'
							result='effect1_dropShadow_5667_24210'
						/>
						<feBlend
							in='SourceGraphic'
							in2='effect1_dropShadow_5667_24210'
							mode='normal'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		</Box>
	);

	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to={PATH_DASHBOARD.app.overview}>{logo}</RouterLink>;
}
